import { render, staticRenderFns } from "./SaiquList.vue?vue&type=template&id=29bd738d&scoped=true&"
import script from "./SaiquList.vue?vue&type=script&lang=js&"
export * from "./SaiquList.vue?vue&type=script&lang=js&"
import style0 from "./SaiquList.vue?vue&type=style&index=0&id=29bd738d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bd738d",
  null
  
)

export default component.exports